<template>
  <div class="main">
    <div>
      <form @submit.prevent>
        <div class="twotables">
            <div class="tablecard">
              <h2 class="heading">Auftrag</h2>
              <table class="toptable">
              <tbody>
                <tr>
                  <th scope="row">
                    <label for="Auftraggeber">Auftraggeber</label>
                  </th>
                  <td>
                    <input type="text" v-model.trim="baustelle.auftraggeber" />
                  </td>
                </tr>

                <tr>
                  <th scope="row">
                    <label for="Rechnungsempfaenger">Rechnungsempfänger</label>
                  </th>
                  <td>
                    <input type="text" v-model.trim="baustelle.empfaenger" />
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    <label for="Rechnungsadresse">Rechnungsadresse</label>
                  </th>
                  <td>
                    <input type="text" v-model.trim="baustelle.rechnungsadresse" />
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    <label for="plz">PLZ, Ort</label>
                  </th>
                  <td>
                    <input type="text" v-model.trim="baustelle.plz" />
                  </td>
                </tr>

                <tr>
                  <th scope="row">
                    <label for="UID">UID Nummer</label>
                  </th>
                  <td>
                    <input type="text" v-model.trim="baustelle.uid" />
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    <label for="Auftragsumme">Auftragssumme netto</label>
                  </th>
                  <td>
                    <input type="number" step="any" v-model.number="baustelle.auftragssumme" />
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    <label for="Zahlungskonditionen">Zahlungskonditionen</label>
                  </th>
                  <td>
                    <input type="text" v-model.trim="baustelle.zkn" />
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    <label for="Auftragsdatum">Auftragsdatum</label>
                  </th>
                  <td>
                    <input type="date" v-model.trim="baustelle.auftragsdatum" />
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    <label for="Auftragsnummer">Auftragsnummer</label>
                  </th>
                  <td>
                    <input type="text" v-model.trim="baustelle.auftragsnummer" />
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    <label for="Info">Anmerkungen</label>
                  </th>
                  <td>
                    <textarea rows="4" cols="100" v-model="baustelle.info"></textarea>
                  </td>
                </tr>
              </tbody>
              </table>
            </div>
            
        <div class="tablecard">
          <h2 class="heading">Baustelle</h2>
          <table class="toptable">
            <tbody>
              <tr>
                <th scope="row">
                  <label for="bauherr">Bauherr</label>
                </th>
                <td>
                  <input type="text" v-model.trim="baustelle.bauherr" />
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="bauherr">Bauvorhaben</label>
                </th>
                <td>
                  <input type="text" v-model.trim="baustelle.bvh" />
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="bauherr">Baustellenadresse</label>
                </th>
                <td>
                  <input type="text" v-model.trim="baustelle.adresse" />
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="Leistungszeitraum">Leistungszeitraum</label>
                </th>
                <td class="zeitraum">
                  Beginn
                  <input class="oneline" type="date" v-model="baustelle.beginn" />
                  Ende
                  <input class="oneline" type="date" v-model="baustelle.ende" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="tablecard">
        <h2 class="heading">Zahlungsplan</h2>
        <table class="zp">
          <tbody>
            <tr class="table-head">
              <th>TR</th>
              <th>Datum</th>
              <th>RG NR</th>
              <th>Leistungsstand</th>
              <th>Rechnungsbetrag</th>
              <th>+20% Mwst</th>
              <th>Verrechnet</th>
              <th>Bezahlt</th>
              <th>Summe bezahlt</th>
            </tr>
            <tr v-for="row in rows" v-bind:key="row.id">
              <td>TR {{ row.TR }}</td>
              <td>
                <input type="date" v-model.trim="row.datum" />
              </td>
              <td>
                <input type="text" v-model.trim="row.rgnr" />
              </td>
              <td>
                <input type="number" v-model.number="row.leistungsstand" />
              </td>
              <td>
                <input type="number" v-model.number="row.rechnungsbetrag" />
              </td>
              <td
                class="dynamic"
              >{{(row.rechnungsbetrag * 0.2 + row.rechnungsbetrag).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}</td>
              <td>
                <input type="checkbox" v-model="row.verrechnet" />
              </td>
              <td>
                <input type="checkbox" v-model="row.bezahlt" />
              </td>
              <td>
                <input type="number" v-model.number="row.summe" />
              </td>
            </tr>
          </tbody>
        </table>

        <div class="controls">
           <div>
            <button 
              class="button" 
              @click="autoZP" 
              :class="{disabled : baustelle.auftragssumme == 0 || baustelle.beginn == null || baustelle.ende == ''}">
                Zahlungsplan automatisch erstellen
            </button>
          </div>

          <div class="row-buttons">
            <button @click="addRow" class="row-button">+</button>
            <div v-if="rows.length > 1">
              <button @click="removeRow" class="row-button">-</button>
            </div>
          </div>

        </div>
      </div>

      <div class="tablecard">
        <h2 class="heading">To Do</h2>
        <table class="todo">
            <tr>
            <td>Vorankündigung</td>
            <td><input type="checkbox" v-model="baustelle.vorankuendigung"></td>
          </tr>
          <tr>
            <td>Unterlage für spätere Arbeiten</td>
            <td><input type="checkbox" v-model="baustelle.ufa"></td>
          </tr>
          <tr>
            <td>Pläne</td>
            <td><input type="checkbox" v-model="baustelle.plaene"></td>
          </tr>
          <tr>
            <td>Firmen</td>
            <td><input type="checkbox" v-model="baustelle.firmen"></td>
          </tr>
          <tr>
            <td>BZP</td>
            <td><input type="checkbox" v-model="baustelle.bzp"></td>
          </tr>
          <tr>
            <td>SiGe</td>
            <td><input type="checkbox" v-model="baustelle.sige"></td>
          </tr>
        </table>
      </div>

      </form>
        <button
          @click="createBaustelle"
          :disabled="baustelle.bauherr == ''"
          class="button create-btn"
        >Speichern</button>
      
    </div>
  </div>
</template>

<script>
import moment, { months } from 'moment';
import { mapState } from "vuex";
import { currentUser } from "../fbConfig";
import router from "../router/index";
const fb = require("../fbConfig.js");

export default {
  data() {
    return {
      baustelle: {
        bauherr: "",
        bvh: "",
        adresse: "",
        auftraggeber: "",
        empfaenger: "",
        rechnungsadresse: "",
        plz: "",
        uid: "",
        auftragssumme: 0,
        zkn: "",
        auftragsdatum: "",
        auftragsnummer: "",
        beginn: "",
        ende: "",
        info: "",
        vorankuendigung: false,
        ufa: false,
        plaene: false,
        firmen: false,
        bzp: false,
        sige: false
      },
      rows: [
        {
          TR: 1,
          id: 1,
          datum: "",
          rgnr: "",
          leistungsstand: "",
          rechnungsbetrag: 0,
          bezahlt: false,
          verrechnet: false,
          summe: 0
        }
      ]
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser"])
  },
  methods: {
    createBaustelle() {
      fb.baustellen
        .add({
          createdOn: new Date(),
          bauherr: this.baustelle.bauherr,
          bvh: this.baustelle.bvh,
          adresse: this.baustelle.adresse,
          auftraggeber: this.baustelle.auftraggeber,
          empfaenger: this.baustelle.empfaenger,
          rechnungsadresse: this.baustelle.rechnungsadresse,
          plz: this.baustelle.plz,
          uid: this.baustelle.uid,
          auftragssumme: this.baustelle.auftragssumme,
          zkn: this.baustelle.zkn,
          auftragsdatum: this.baustelle.auftragsdatum,
          auftragsnummer: this.baustelle.auftragsnummer,
          beginn: this.baustelle.beginn,
          ende: this.baustelle.ende,
          info: this.baustelle.info,
          userId: this.currentUser.email,
          userName: this.userProfile.name,
          zahlungsplan: this.rows,
          vorankuendigung: this.baustelle.vorankuendigung,
          ufa: this.baustelle.ufa,
          plaene: this.baustelle.plaene,
          firmen: this.baustelle.firmen,
          bzp: this.baustelle.bzp,
          sige: this.baustelle.sige
        })
        .then(ref => {
          router.push({ name: "Baustellen" });
        })
        .catch(err => {
          console.log(err);
        });
    },
    addRow() {
      let nextRow = this.rows[this.rows.length - 1].TR + 1;
      this.rows.push({
        TR: nextRow,
        id: nextRow,
        datum: "",
        rgnr: "",
        leistungsstand: "",
        rechnungsbetrag: 0,
        bezahlt: false,
        summe: 0
      });
    },
    removeRow() {
      this.rows.pop();
    },
    autoZP() {
      this.rows = []
      const durationMonths = moment(this.baustelle.ende).diff(moment(this.baustelle.beginn), 'months', true)
      
      if (durationMonths < 8) {
        this.rows.push({
          TR: 'SR',
          id: 1,
          datum: moment(this.baustelle.ende).add(1, 'months').endOf('month').format('YYYY-MM-DD'),
          rgnr: '',
          leistungsstand: '',
          rechnungsbetrag: this.baustelle.auftragssumme,
          bezahlt: false,
          summe: 0
        })
      } else {
        const numTRs = Math.ceil(durationMonths / 5)
        const sumTRs = this.baustelle.auftragssumme / numTRs
        const sumTRsRounded = Math.ceil(sumTRs / 50) * 50

        let trs = []

        for (let index = 0; index < numTRs; index++) {
          trs.push({
            TR: index + 1,
            id: index + 1,
            datum: moment(this.baustelle.beginn, 'YYYY-MM-DD').add(5 * (index + 1), 'months').endOf('month').format('YYYY-MM-DD'),
            rgnr: '',
            leistungsstand: '',
            rechnungsbetrag: sumTRsRounded,
            bezahlt: false,
            summe: 0
          })
        }

        const sr = trs.pop()
        sr.TR = 'SR'
        sr.rechnungsbetrag = this.baustelle.auftragssumme - (sumTRsRounded * trs.length)
        sr.datum = moment(this.baustelle.ende, 'YYYY-MM-DD').add(1, 'months').endOf('month').format('YYYY-MM-DD')
        
        trs.forEach(el => {
          this.rows.push(el)
        })
        this.rows.push(sr)
      }
    }
  }
};
</script>

<style scoped>
.main {
  margin-top: 100px;
}

.twotables {
  display: flex;
}

.tablecard {
  background: #eeeeee;
  padding: 20px;
  border-radius: 20px;
  margin-right: 20px;
  margin-bottom: 20px;
}

.heading {
  margin-top: 0;
}

table {
  text-align: left;
  border-collapse: collapse;
}

.table-head {
  background: #2c3e50;
  color: #eeeeee;
  font-size: 14px;
}

th {
  padding: 0.5rem;
}

.toptable tr {
  height: 40px;
}

.toptable th {
  vertical-align: bottom;
  border-bottom: 1px solid rgb(212, 212, 212);
}

.zp td,
.zp th {
  border: 1px solid rgb(212, 212, 212);
}

.zp td {
  background: rgb(247, 247, 247);
}

.zp td:first-of-type {
  padding-left: 0.5rem;
}

.zp {
  width: 100%;
  table-layout: auto;
}

input {
  width: 100%;
  box-sizing: border-box;
  padding: 12px;
  border: none;
  outline: none;
  background: transparent;
  font-family: "Avenir";
}

.toptable input {
  background: rgb(247, 247, 247);
  height: 35px;
  border-radius: 20px;
}

textarea {
  background: rgb(247, 247, 247);
  outline: none;
  padding: 10px;
  font-family: "Avenir";
  border-radius: 20px;
  height: 40px;
}

.toptable td:last-of-type {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.zeitraum {
  padding-left: 10px;
  height: 40px;
}

.oneline {
  width: 150px;
  padding: 10px;
  margin: 0 5px 0 5px;
}

.row-buttons {
  display: flex;
}

.row-button {
  border: none;
  font-size: 1.1em;
  font-weight: bold;
  margin-top: 5px;
  margin-left: 2px;
  border: 1px solid #999;
  cursor: pointer;
  width: 30px;
  height: 30px;
}

.row-button:hover {
  border: 1px solid #2c3e50;
  color: #fff;
  background: #2c3e50;
}

.controls {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.form-button {
  display: block;
  margin: 10px 0;
}

.create-btn {
  margin-top: 10px;
  margin-left: 2px;
}

.dynamic {
  padding: 0 5px;
}

.todo {
  width: 65%;
  text-align: left;
}

.todo td {
  border: 1px solid rgb(212, 212, 212);
  padding: 0.5rem;
}

.disabled {
  background: lightgray;
  border: 1px solid lightgray;
  pointer-events: none;
}
</style>